import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { SLIDE_UP_ANIMATION } from '../../../animations/slide-up.animation';
import {GoBackButtonService} from '../../../services/go-back-button.service';
import {AlternativeDatatablesComponent} from '../../../shared/alternative-datatables/alternative-datatables.component';
import {AlternativeDatatablesInterface} from '../../../shared/alternative-datatables/alternative-datatables.interface';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Subject, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {JsonClientService} from '../../../shared/json-client';
import {NotificationService} from '../../../services/notification.service';
import {debounceTime} from 'rxjs/operators';
import {TemplateService} from '../../../services/template.service';
import {BreadcrumbsService} from '../../../shared/breadcrumbs/services';
import {PartRatePipe} from '../../../pipes/part-rate.pipe';


@Component({
    selector: 'app-condition-list',
    templateUrl: './condition-list.component.html',
    styleUrls: [
        './condition-list.component.scss',
    ],
    animations: [SLIDE_UP_ANIMATION],
    standalone: false
})
export class ConditionListComponent
  extends AlternativeDatatablesComponent
  implements AlternativeDatatablesInterface, OnInit, OnDestroy, AfterViewInit {

  public head;

  public filterColumns = {};
  public form: UntypedFormGroup;
  public filter: string;
  public formGroup: UntypedFormGroup;
  public _data;
  public loading = false;
  public settings_id = [];
  public _searchField = '';
  public get searchField() {
    return this._searchField;
  }
  public set searchField(value) {
    this._searchField = value;
    this.searchFieldIds = []; // Очищаем массив при каждом изменении
    this.searchFieldError = false;

    if (!this.complexes || !this.complexes.controls) {
      return;
    }

    const searchLower = value.toLowerCase().trim();
    if (!searchLower) {
      return;
    }

    // Проходим по всем элементам FormArray и ищем совпадения
    this.complexes.controls.forEach((complex, index) => {
      const caption = complex.get('caption')?.value;

      if (caption && typeof caption === 'string') {
        const captionLower = caption.toLowerCase();

        // Если найдено совпадение - добавляем индекс в массив
        if (captionLower.includes(searchLower)) {
          this.searchFieldIds.push(complex.get('realty_id')?.value);
        }
      }
    });

    if (!this.searchFieldIds.length) {
      this.searchFieldError = true;
    }
  }

  public get complexes(): UntypedFormArray {
    return this.formGroup.get('complexes') as UntypedFormArray;
  }

  public get settings(): UntypedFormArray {
    return this.formGroup.get('settings') as UntypedFormArray;
  }

  public get defaults(): UntypedFormGroup {
    return this.formGroup.get('default') as UntypedFormGroup;
  }

  public searchFieldError = false;
  public searchFieldIds: string[] = [];

  private parasites = true;

  public filterSubject: Subject<void> = new Subject<void>();
  private filterSubscription: Subscription;
  private formSubscription: Subscription;

  public currentPage = 1;

  public count;
  public rows;

  public sort: { [key: string]: string } = {};

  public modalShow = false;
  public modalContent = '';
  public modalCaption = '';

  public developerId: any;
  public developerCaption: any;
  public activeRewriteButton = true;

  public set data(value) {
    this._data = value;
    this.count = value['count'];
    this.rows = value['rows'];
  }
  public get data() {
    return this._data;
  }

  public set searchValue(value: any) {
    this.filter = value;
    this.onFilterChanges(this.filter);
  }

  public get searchValue(): any {
    return this.filter;
  }


  constructor(public http: JsonClientService,
              private notify: NotificationService,
              public goBack: GoBackButtonService,
              private b: BreadcrumbsService,
              private router: Router,
              private fb: UntypedFormBuilder,
              public activatedRoute: ActivatedRoute,
              private template: TemplateService,
              private cdr: ChangeDetectorRef,
              private partRate: PartRatePipe) {
    super(router, activatedRoute, fb, http);

    this.filterSubscription = this.filterSubject
      .pipe(debounceTime(500))
      .subscribe(_ => this.onFilterChanges());
  }

  bSet() {
    this.http.post('Condition.get_developer_caption', { developer_id: this.developerId })
      .then((data: any) => {

        this.developerCaption = typeof data === 'string' ? data : data?.caption || '';

        if (this.developerCaption) {
          this.goBack.header = '<h2>Условия реализации ' + this.developerCaption + '</h2>';
          this.b.set([
            {url: '/index', caption: 'Главная'},
            {url: '/condition/developer', caption: 'Условия реализации и КВ'},
          ]);
          this.template.setHeader('Условия реализации ' + this.developerCaption);
        }
      });
  }

  ngOnInit() {
    this.form = this.fb.group({});
    this.developerId = Number(this.activatedRoute.snapshot.params['id']);
    this.head = [
      {'name': 'date_to', 'value': '', 'caption': 'Дата с', 'sort': false, 'input': false},
      {'name': 'date_from', 'value': '', 'caption': 'Дата по', 'sort': false, 'input': false},
      {'name': 'text', 'value': '', 'caption': 'Условия', 'sort': false, 'input': false},
      {'name': 'is_edit', 'value': '', 'caption': '', 'sort': false, 'input': false},
    ];

    this.head = this.head.map(x => {
      x.value = this.activatedRoute.snapshot.queryParams[x.name] || x.value;
      return x;
    });
    if (this.activatedRoute.snapshot.queryParams['sort_name']) {
      this.sort[this.activatedRoute.snapshot.queryParams['sort_name']] = this.activatedRoute.snapshot.queryParams['sort_key'];
    }

    this.formSubscription = this.form.valueChanges
      .subscribe(_ => this.filterSubject.next());

    for (const el of this.head) {
      this.form.addControl(el.name, new UntypedFormControl(el.value));
    }

    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.onInitCall();

    this.settings_id = this.data['settings'].map((item) => item['realty_id']);
    const disable = !this.data['default']['is_active'];
    this.formGroup = this.fb.group({
      'default': this.fb.group({
        'is_active': [this.data['default']['is_active']],
        'flat_agent_ddu_percent': [{value: this.data['default']['flat_agent_ddu_percent'], disabled: disable}],
        'flat_sa_agd_percent': [{value: this.data['default']['flat_sa_agd_percent'], disabled: disable}],
        'date_to': [{value: this.data['default']['date_to'], disabled: disable}],
      }),
      'complexes': this.fb.array(this.data['complexes'].map((item) => {
        return this.fb.group({
          'realty_id': item['id'],
          'caption': item['caption'],
          'imp_settings': [item['imp_settings']],
          'is_checked': item['is_checked'],
        });
      })),
      'settings': this.fb.array(this.data['settings'].map((item) => {
        const disable = !item['is_active'];
        return this.fb.group({
          'id': item['id'],
          'realty_id': item['realty_id'],
          'caption': item['caption'],
          'imp_settings': [item['imp_settings']],
          'is_active': item['is_active'],
          'flat_agent_ddu_percent': [{value: item['flat_agent_ddu_percent'], disabled: disable}],
          'flat_sa_agd_percent': [{value: item['flat_sa_agd_percent'], disabled: disable}],
          'date_to': [{value: item['date_to'], disabled: disable}],
        });
      }))
    });

    this.defaults.get('is_active').valueChanges.pipe(debounceTime(100))
      .subscribe((data) => {
        this.setDisabled(this.defaults, data);
      });
    this.settings.controls.forEach(item => {
      item.get('is_active').valueChanges.subscribe((data) => {
        this.setDisabled(item, data);
      });
    });
    this.complexes.valueChanges.pipe(debounceTime(100))
      .subscribe((data) => {
        data.forEach((item) => {
          const index = this.settings_id.indexOf(item.realty_id);
          if (item.is_checked && index !== -1) {
            this.settings_id.splice(index, 1);
            this.settings.removeAt(index);
          }
          if (!item.is_checked && index === -1) {
            this.settings_id.push(item.realty_id);
            this.appendSettings(item);
          }
        });
      });
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  onFilterChanged(): void {
    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.data = this.activatedRoute.snapshot.data['data'];
    this.currentPage = +this.activatedRoute.snapshot.queryParams['page'] || 1;
  }

  onFilterChanges(text = null) {
    if (text !== null) {
      this.filter = text;
    }

    this.filterColumns = {};
    const cols = [...this.head];
    for (const el of cols) {
      if (!this.form.get(el.name).value.length) {
        continue;
      }
      this.filterColumns[el.name] = this.form.get(el.name).value;
    }
    if (this.filter !== '') {
      this.filterColumns['global_search_string'] = this.filter;
    }
    if (this.sort) {
      this.filterColumns['sort_name'] = Object.keys(this.sort)[0];
      this.filterColumns['sort_key'] = this.sort[this.filterColumns['sort_name']];
    }
    if (this.parasites) {
      return this.parasites = !this.parasites;
    }
    this.bSet();
    this.router.navigate(['realty-showcase-items'], {
      queryParams: this.getQueryParams(),
    });
  }

  getQueryParams() {
    const query_params = {}, cols = [...this.head];
    for (const el of cols) {
      let _val = this.form.get(el.name).value;
      if (!_val.length) {
        continue;
      }
      if (_val === 'true' || _val === 'false') {
        _val = _val === 'true';
      }
      query_params[el.name] = _val;
    }
    if (this.sort) {
      query_params['sort_name'] = Object.keys(this.sort)[0];
      query_params['sort_key'] = this.sort[query_params['sort_name']];
    }
    if (this.filter !== '') {
      query_params['global_search_string'] = this.filter;
    }
    return query_params;
  }

  prepareSort(column_name: string) {
    for (const key in this.sort) {
      if (column_name !== key) {
        delete this.sort[key];
      }
    }
  }

  sortChange(column_name: string) {
    this.prepareSort(column_name);
    this.sort[column_name] = !this.sort[column_name] || ('desc' === this.sort[column_name]) ? 'asc' : 'desc';
    this.onFilterChanges();
  }

  ngAfterViewInit() {
    this.bSet();
    this.goBack.goScroll();
    this.cdr.detectChanges();
  }

  viewDetailInfo(condition: any, event) {
    event.stopPropagation();
    this.modalShow = true;
    this.modalCaption = 'Условия реализации';
    this.modalContent = condition;
  }

  modalClose() {
    this.modalShow = false;
    this.modalCaption = '';
    this.modalContent = '';
  }

  rewriteCondition() {
    this.activeRewriteButton = false;
    this.http.post('Condition.percent_developer_rewrite', {'developer_id': this.developerId})
      .then(
        (response) => {
          this.activeRewriteButton = true;
          if (response === true) {
            this.notify.notifySuccess('Готово', 'Данные на застройщике успешно перезаписаны', 5000);
          } else {
            this.notify.notifyError('Ошибка', 'Что-то пошло не так', 5000);
          }
        },
        (error) => {
          this.notify.notifyError('Ошибка', error, 5000);
          this.activeRewriteButton = true;
        });
  }


  appendSettings(data) {
    const disable = !this.defaults.value.is_active;
    const form = this.fb.group({
      'id': null,
      'realty_id': data.realty_id,
      'caption': data.caption,
      'imp_settings': [data.imp_settings],
      'is_active': this.defaults.value.is_active,
      'flat_agent_ddu_percent': [{value: this.defaults.value.flat_agent_ddu_percent || null, disabled: disable}],
      'flat_sa_agd_percent': [{value: this.defaults.value.flat_sa_agd_percent || null, disabled: disable}],
      'date_to': [{value: this.defaults.value.date_to || null, disabled: disable}],
    });
    this.settings.push(form);
    form.get('is_active').valueChanges.subscribe((data) => {
      this.setDisabled(form, data);
    });
  }

  saveForm() {
    if (!this.formGroup.valid) {
      this.onError('Заполните обязательные поля');
      return false;
    }
    this.loading = true;

    const settingObj = [];
    for (const el of  this.formGroup.get('settings').value) {
      settingObj.push(Object.assign({}, el));
    }

    const data = {
      'developer_id': this.developerId,
      'data': {
        'default': Object.assign({}, this.formGroup.get('default').value),
        'complexes': Object.assign({}, this.formGroup.get('complexes').value),
        'settings': settingObj,
      }
    };


    let correctPercent = true;
    if (
      parseFloat(data['flat_agent_ddu_percent']) > (parseFloat(data['flat_sa_agd_percent'])
        ? parseFloat(data['flat_sa_agd_percent']) : 0)
    ) {
      correctPercent = false;
    }

    data['data']['default']['dolya_subagenta_agd'] = this.partRate.transform(
      data['data']['default']['flat_agent_ddu_percent'], data['data']['default']['flat_sa_agd_percent']);

    if (correctPercent) {
      for (let i = 0; i < this.settings.controls.length; i++) {
        if (data['data']['settings'][i]['flat_agent_ddu_percent']) {
          data['data']['settings'][i]['flat_agent_ddu_percent'] =
            data['data']['settings'][i]['flat_agent_ddu_percent'].toString().replace(',', '.');
        }
        if (data['data']['settings'][i]['flat_sa_agd_percent']) {
          data['data']['settings'][i]['flat_sa_agd_percent'] =
            data['data']['settings'][i]['flat_sa_agd_percent'].toString().replace(',', '.');
        }
        if (
          parseFloat(data['data']['settings'][i]['flat_sa_agd_percent'])
          > (parseFloat(data['data']['settings'][i]['flat_agent_ddu_percent'])
            ? parseFloat(data['data']['settings'][i]['flat_agent_ddu_percent']) : 0)
        ) {
          correctPercent = false;
          break;
        }

        data['data']['settings'][i]['dolya_subagenta_agd'] =
          this.partRate.transform(data['data']['settings'][i]['flat_agent_ddu_percent'],
            data['data']['settings'][i]['flat_sa_agd_percent']);

        if (data['data']['settings'][i]['dolya_subagenta_agd'] > 1) {
          correctPercent = false;
          break;
        }
      }
    }

    if (data['data']['default']['dolya_subagenta_agd'] > 1 || !correctPercent) {
      this.notify.notifyError('Ошибка', 'Неверный процент субагента', 3000);
      this.loading = false;
    } else {
      this.http.post('Condition.set_complex_remuneration', data).then(
        (response) => {
          this.onSuccess(response);
          this.loading = false;
        },
        (error) => {
          this.onError(error);
          this.loading = false;
        }
      );
    }

  }

  setDisabled(form, is_active) {
    if (is_active) {
      form.get('flat_agent_ddu_percent').enable();
      form.get('flat_sa_agd_percent').enable();
      form.get('date_to').enable();
    } else {
      form.get('flat_agent_ddu_percent').disable();
      form.get('flat_sa_agd_percent').disable();
      form.get('date_to').disable();
    }
  }

  onSuccess(response?) {
    this.notify.notifySuccess('Поздравляем', 'Настройки успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', error, 5000);
  }

}
